import { AryaEvent } from '@digital-bridge/artisan-arya';
import * as Hooks from 'preact/hooks';
import * as O from 'fp-ts/Option';
import { Interface } from '../../arya/interface';

export function useSelectedState(aryaRef: O.Option<Interface>) {
    const [selectedFurniture, setSelectedFurniture] = Hooks.useState<string>();

    Hooks.useEffect(() => {
        const onFurnitureSelect = () => {
            const selectedFurniture = O.toNullable(aryaRef)?.selectedFurniture();
            if (selectedFurniture && selectedFurniture[0] !== undefined) {
                setSelectedFurniture(selectedFurniture[0]);
            }
        };

        const onFurnitureDeselect = () => {
            setSelectedFurniture(undefined);
        };
        O.toNullable(aryaRef)?.on(AryaEvent.FURNITURE_SELECTED, onFurnitureSelect);
        O.toNullable(aryaRef)?.on(AryaEvent.FURNITURE_DESELECTED, onFurnitureDeselect);

        return () => {
            O.toNullable(aryaRef)?.off(AryaEvent.FURNITURE_SELECTED, onFurnitureSelect);
            O.toNullable(aryaRef)?.off(AryaEvent.FURNITURE_DESELECTED, onFurnitureDeselect);
        };
    }, [aryaRef]);
    return selectedFurniture;
}
